<template>
    <!-- eslint-disable max-len -->
    <div class="cookie-wrapper">
        <div class="cookiebar state-inactive">
            <div class="container">
                <div class="row">
                    <div class="col cookiebar__content">
                        <span>
                            {{ cookieText.cookieBarText }}
                        </span>
                        <a data-cookies-open
                            >{{ cookieText.cookieBarLinkText }}
                        </a>
                        <a class="btn" @click.prevent="acceptCookies">{{
                            cookieText.cookieButtonAcceptCookies
                        }}</a>
                    </div>
                </div>
            </div>
        </div>
        <cookieModal :cookie-text="cookieText"></cookieModal>
    </div>
</template>

<script>
import Cookies from 'js-cookie';
import CookieModal from '@/components/cookies/cookie-modal';
import { EventBus } from '../../js/helpers/eventbus';

export default {
    components: {
        CookieModal
    },
    props: {
        cookieText: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            $cookiebar: null,
            $open: null,
            visited: null
        };
    },

    created() {
        this.visited = Cookies.get('allowCookiesCookie');
    },

    mounted() {
        this.$cookiebar = document.querySelector('.cookiebar');
        this.$open = document.querySelector('[data-cookies-open]');

        if (this.$open) {
            this.$open.addEventListener('click', this.openModelCookies);
        }
        if (this.visited === 'undefined' || !this.visited) {
            this.$cookiebar.classList.remove('state-inactive');
        }
    },
    methods: {
        openModelCookies() {
            EventBus.$emit('open-cookiemodal');
            this.$root.cookieDialog = true;
        },
        acceptCookies() {
            EventBus.$emit('accept-cookies');
        }
    }
};
</script>
<style lang="scss" scoped>
.cookiebar {
    position: fixed;
    width: 100%;
    bottom: 0;
    z-index: $zindex-popover;
    transition: all 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);
    background-color: $color-blue;
    color: #fff;
    font-size: 17px;

    a {
        color: $color-white;
        text-decoration: none;
        font-weight: bold;
        cursor: pointer;
    }

    .btn {
        background-color: $color-white;
        font-weight: normal;
        color: $color-black;
        padding: 12px 2rem;
        margin: 1rem auto 0;
        max-width: 280px;
        display: block;
        cursor: pointer;

        &:hover {
            color: $color-black;
        }

        @include media-breakpoint-up(xl) {
            margin: 0 0 0 40px;
            display: inline-block;
        }
    }

    .button--accept {
        position: relative;
        background-color: $color-green;
        color: $color-white;
        padding: 2px 7px;
        border: 0;
        margin: 0px 0px 10px 25px;
        font-size: 22px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
        border-radius: 2px;
    }

    &__content {
        padding: 20px;
        text-align: center;

        @include media-breakpoint-up(xl) {
            text-align: left;
        }
    }

    &.state-inactive {
        transform: translate(0, 100%);
    }
}

@media print {
    .cookiebar {
        display: none;
    }
}
</style>
